/**
 * Session state persisted by api.js. Read synchronously at boot by App.js
 * (initial auth state) and after mount by the landing nav ("Mon espace").
 */
export const SESSION_EXPIRES_AT_KEY = 'session_expires_at';
export const TEACHER_INFO_KEY = 'teacher_info';

const nowSeconds = () => Math.floor(Date.now() / 1000);

const read = (key) => {
  try { return localStorage.getItem(key); } catch { return null; }
};

export const hasStoredTeacher = () => !!read(TEACHER_INFO_KEY);

export const storedSessionExpired = () => {
  const expiresAt = parseInt(read(SESSION_EXPIRES_AT_KEY), 10);
  return !expiresAt || expiresAt <= nowSeconds();
};

/** A teacher is stored and the access token has not expired. */
export const hasLiveStoredSession = () => hasStoredTeacher() && !storedSessionExpired();

/** A teacher is stored but the token expired: App tries a silent refresh. */
export const needsSilentRefresh = () => hasStoredTeacher() && storedSessionExpired();
